// tabs collection 
$('.collection_tabs_wrapper').each(function() {
    var $section = $(this); // This is the unique section wrapper
    
    // Handle clicks only within this specific section
    $section.find('.tab-btn').on('click', function(e) {
        e.preventDefault();

        // 1. Update Tabs in THIS section only
        $section.find('.tab-item').removeClass('active');
        $(this).parent().addClass('active');

        // 2. Update Content in THIS section only
        var activeTab = $(this).attr('href');
        $section.find('.tabs-content-item').hide();
        
        var $activeContent = $section.find(activeTab);
        if ($activeContent.length) {
            $activeContent.fadeIn(300);
        }
    });

    // Initialize: Show first tab of this specific section
    $section.find('.tabs-content-item').hide().first().show();
    $section.find('.tab-item').first().addClass('active');
});